<template>
  <!-- 发票明细 -->
  <div class="page-container" id="invoiceDetailContainer">
    <el-form :model="invoiceDetailForm"
            :inline="true"
             ref="ruleFormRef"
             class="form-panel"
             label-position="left"
             label-width="80px"
            >
      <el-row class="content-panel" style="border-radius: 10px">
        <el-row style="margin-bottom:10px">
            <el-button type="primary" size="small" plain @click="downloadAttachment()">Download</el-button>
        </el-row>
        <el-row :gutter="5"  style="margin: 0px">
          <el-col :span="8" style="margin: -5px" >
            <el-form-item label="ATTN:">
              <el-input
                size="mini"
                type="textarea"
                :rows="5"
                style="width: 300px"
                v-model="invoiceDetailForm.settleAgentName"
                disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16" >
            <el-row  :gutter="5" style="margin: -5px">
              <el-col :span="12" style="margin: -5px">
                <el-form-item label="Note No:">
                  <el-input style="width: 300px" v-model="invoiceDetailForm.agentCompNo" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" style="margin: -5px" >
                <el-form-item label="Type:">
                  <el-select clearable v-model="invoiceDetailForm.invoiceType" placeholder="Please select the invoice type" disabled style="width:300px;">
                    <el-option
                      v-for="item in invoiceTypeList"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                      disabled="true"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5" style="margin: -5px">
              <el-col :span="12" style="margin: -5px">
                <el-form-item label="ISSUED BY:">
                  <el-input style="width:300px;" v-model="invoiceDetailForm.agentCompPersonNameEn" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" style="margin: -5px;">
                <el-form-item label="INV DATE:" size="mini">
                  <el-date-picker
                    v-model="invoiceDetailForm.createTime"
                    type="date"
                    style="width:300px;line-height:36px"
                    disabled
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          </el-row>

      </el-row>

      <el-row class="panel-top" type="flex" justify="space-between" align="top">
          <el-row type="flex" justify="start" align="top" :gutter="10" style="margin:8px 0px">
            <hot-table
              ref="invoiceContentTableRef"
              :data-source="bcPublicOrdersTable"
              :settings="invoiceContentTableSettings"
              col-settings-key="invoiceContentKey"
              @cellDblclick="invoiceContentTableCellClick"
              :rules="invoiceContentTableRules"
            >
              <hot-column :has-tip="true" data="mblNo" title="BO/L#:"></hot-column>
              <hot-column :has-tip="true" data="vesselName" title="VSL/VOY" ></hot-column>
              <hot-column :has-tip="true" data="etd" date-format="YYYY-MM-DD" title="ETD" ></hot-column>
              <hot-column :has-tip="true" data="polName" title="P.LOAD" ></hot-column>
              <hot-column :has-tip="true" data="podName" title="P.DISCHAR" ></hot-column>
              <hot-column :has-tip="true" data="placeOfDeliveryName" title="P.DELIVERY" ></hot-column>
              <hot-column :has-tip="true" data="partyDescriptionSH" title="(SH)" ></hot-column>
              <hot-column :has-tip="true" data="partyDescriptionCN" title="(CO)" ></hot-column>
              <hot-column :has-tip="true" data="partyDescriptionNT" title="(NF)" ></hot-column>
              <hot-column :has-tip="true" data="cargoName" title="COMMODITY:" ></hot-column>
            </hot-table>
          </el-row>

      </el-row>
      <el-row class="panel-top" type="flex" justify="space-between" align="top">
            <el-row type="flex" justify="start" align="top" :gutter="10" style="margin:8px 0px">
              <hot-table
                ref="invoiceTableRef"
                :data-source="bcFreightsTable"
                :settings="expenseInformationTableSettings"
                col-settings-key="invoiceContentKey"
              >
                <hot-column :has-tip="true" data="freightNameEn" title="Description"></hot-column>
                <hot-column :has-tip="true" data="settleCurrencyCode" title="Currency"></hot-column>
                <hot-column :has-tip="true" data="unitPrice" title="PRICE"></hot-column>
              </hot-table>
            </el-row>
      </el-row>
                  <el-row type="flex" justify="start" align="top" :gutter="10">
              <el-col class="TTL">
                <el-form-item label="TTL: " style="float:right" class="redItem nomargin">
                    <el-row style="color: #ee0000">{{invoiceDetailForm.amountSum}}</el-row>
                </el-form-item>
              </el-col>
            </el-row>
      <el-dialog
        :visible.sync="mdReportTemplateVisible"
        title="打印"
        :append-to-body="true"
        :close-on-click-modal="true"
        width="70%"
      >
        <el-row>
          <el-button class="el-button-search" type="primary" size="small" plain @click="preview()" >预览</el-button>
          <el-button class="el-button-search" type="primary" size="small" plain   >打印</el-button>
        </el-row>
        <el-row style="margin-top: 15px;margin-bottom: 20px;height: 300px">
          <hot-table
            ref="mdReportTemplateTableRef"
            :data-source="mdReportTemplateData"
            col-settings-key="onlineServiceDialogTable"
          >
            <hot-column :has-tip="true" data="templateNameCn" title="套版名称" width="150"></hot-column>
          </hot-table>
          <!-- 分页start -->
          <!-- 分页end -->
        </el-row>
      </el-dialog>

<!--      <el-row :gutter="22" class="bottom-module">-->
<!--        <el-col :span="12" class="bottom-input">-->
<!--          <el-row>-->
<!--            <el-form-item label="Beneficiary:" class="widthSH" label-width="100px"> <el-input v-model="invoiceDetailForm.settleOfficeName"></el-input></el-form-item>-->
<!--          </el-row>-->
<!--          <el-row>-->
<!--            <el-form-item label="Beneficiary Bank:" class="widthSH" label-width="100px"> <el-input v-model="invoiceDetailForm.bankNameEn"></el-input></el-form-item>-->
<!--          </el-row>-->
<!--          <el-row>-->
<!--            <el-form-item label="Bank Address:" class="widthSH" label-width="100px"> <el-input v-model="invoiceDetailForm.bankAddressEn"></el-input></el-form-item>-->
<!--          </el-row>-->
<!--          <el-row>-->
<!--            <el-form-item label="Swift Code:" class="widthSH" label-width="100px"> <el-input v-model="invoiceDetailForm.swiftCode"></el-input></el-form-item>-->
<!--          </el-row>-->
<!--        </el-col>-->
<!--        <el-col :span="12" class="bottom-input">-->
<!--          <el-row>-->
<!--            <el-form-item label="Beneficiary Bank Account:" label-width="160px" class="widthSH"> <el-input v-model="beneficiaryBankAccount[0]"></el-input></el-form-item>-->
<!--          </el-row>-->
<!--          <el-row>-->
<!--            <el-form-item label=" " class="widthSH" label-width="160px"> <el-input v-model="beneficiaryBankAccount[1]"></el-input></el-form-item>-->
<!--          </el-row>-->
<!--          <el-row>-->
<!--            <el-form-item label=" " class="widthSH" label-width="160px"> <el-input v-model="beneficiaryBankAccount[2]"></el-input></el-form-item>-->
<!--          </el-row>-->
<!--          <el-row>-->
<!--            <el-form-item label=" " class="widthSH" label-width="160px"> <el-input v-model="beneficiaryBankAccount[3]"></el-input></el-form-item>-->
<!--          </el-row>-->
<!--        </el-col>-->
<!--      </el-row>-->

    </el-form>
  </div>
</template>

<script>

import { queryDictRows,queryDictionaryByCodeType } from "@/api/commonService";
import { queryInvoice,downloadInvoice } from "@/api/queryMainSystem";
import { queryInvoiceDetailInfo } from "@/api/overseas"
import {queryMdReportTemplate} from "@/api/common";

export default {
  name: 'InvoiceDetail',
  data() {
    return {
      mdReportTemplateVisible: false,
      invoiceUrl: '',
      invoiceTypeList: [], //发票类型
      invoiceDetailForm: {},
      /* 发票信息表 */
      bcPublicOrdersTable: [],
      /* 费用信息表 */
      bcFreightsTable: [],
      beneficiaryBankAccount: [],
      // 发票内容
      invoiceContentTableDataSource: [],
      bcFreights: [],
      invoiceContentTableSettings: {
        height: 110,
        autoColumnSize: true,
        stretchH: 'all', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
      },
      expenseInformationTableSettings: {
        height: 220,
        autoColumnSize: true,
        stretchH: 'all', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
        showSelection: false,
      },
      invoiceContentTableRules: {},
      searchData: {
        invoiceSettlementCustomer: null,
        invoiceNumber: null,
        invoiceType: null,
        issuedBy: null,
        issuedDate: null,
      },
      mdReportTemplateData: [],
      //
      bcPublic_columns_nameVoyage: [
        {
          title: "VSL/VOY",
          field: "bcPublicNameVoyage",
        },
      ],
    };
  },
  async created() {

    this.examId = this.$route.params.key;
  },
  mounted() {
    let self = this
    self.expenseInformationTableSettings.height = document.body.clientHeight-440
    self.queryDict();
     if(self.$route.query.bcAgentCompId) {
       var queryParm={
         bcAgentCompId: self.$route.query.bcAgentCompId
       }
      queryInvoiceDetailInfo(queryParm).then(res => {
       self.invoiceDetailForm = res.records
        self.invoiceDetailForm.invoiceType = self.$route.query.invoiceType;
       self.bcPublicOrdersTable = res.records.bcPublicOrders
       self.bcFreightsTable= res.records.bcFreights
       self.beneficiaryBankAccount = res.records.beneficiaryBankAccount
      })
    }
    // 监听外层容器div宽度的变化，做表格自适应
    self.resizeObserver = new ResizeObserver(entries => {
      self.$nextTick(() => {
        self.$refs.invoiceContentTableRef.resizeTo(entries[0].target.clientWidth - 32)
        self.$refs.invoiceTableRef.resizeTo(entries[0].target.clientWidth - 32)
      })
    })
    self.resizeObserver.observe(document.getElementById("invoiceDetailContainer"))
  },
  methods: {
    //联想控件
    bcPublic_queryMethod_nameVoyage(){

    },
    queryDict() {
      let self = this;
     let params={
        codeType: "MD_INVOICE_TYPE",
        valueType: 'ZH'
      }
      if(this.$cookies.get('language')==='en'){
		  params={
        codeType: "MD_INVOICE_TYPE",
        valueType: 'EN',
        }
		 }
     queryDictionaryByCodeType(params).then((res) => {
        let dict = [];
        // res.MD_CODE_DICT$MD_INVOICE_TYPE.forEach((item) => {
        //   let param = {};
        //   param.value = item.value;
        //   param.key = item.key;
        //   param.count = 0;
        //   param.filterList = [];
        //   dict.push(param);
        //   self.invoiceTypeList.push(param);
        // });
        self.invoiceTypeList = res.records.MD_INVOICE_TYPE;
        console.log("invoiceTypeList", dict);
      });
    },
    //修改日期
    changeissuedDateTo() {
      let self = this;
      self.searchData.issuedDateTo = new Date(self.searchData.issuedDateTo.getTime() + 1000 * 24 * 3600 - 100)
    },
    //行单击事件
    invoiceContentTableRowClick() {

    },
    //双击事件
    invoiceContentTableCellClick() {

    },
    //下载附件
    downloadAttachment() {
      let self = this;
      self.mdReportTemplateVisible= true;
      // downloadInvoice(self.invoiceUrl).then(res => {
      //   if(res.success) {
      //     self.$coreMethods.message("info", "开始下载");
      //   }else{
      //     self.$coreMethods.message("error", "下载失败");
      //   }
      // });

      //查询套版
      let searchData = {
        apiKey : "CTS_ILP_MdReportTemplate",
        sqlKey: "CTS_ILP_MdReportTemplate",
        tag: "CTS_ILP_MdReportTemplate",
        reqArgs: {"templateTypeCode": ""},
        action: "query",
        returnTotal: false
      }
      queryMdReportTemplate(searchData).then((res) => {
        console.log("queryTemplate", res);
        if (res.success == true ) {
          self.mdReportTemplateData = res.data;
          // if (res.data.length === 0){
          //   self.$coreMethods.message("warning", "没有数据，请重新输入查询条件！");
          // }else {
          //   self.$coreMethods.message("success", "查询成功！");
          // }
        }
      });
    },
    preview(){
      let self = this;
      if(self.$refs.mdReportTemplateTableRef.getSelections().length==1){

        if(self.$refs.mdReportTemplateTableRef.getSelected().reportUrl==null){
          self.$coreMethods.message("error", this.$t('message.pleaseCheck'));
          return;
        }

        self.mdReportTemplateVisible= false;
        self.$router.push({
          name: "reportShow",
          query: {
            systemType: self.$refs.mdReportTemplateTableRef.getSelected().systemType,
            reportUrl: self.$refs.mdReportTemplateTableRef.getSelected().reportUrl,
            primaryId: self.reportPrimaryId
          }
        });
      }else {
        self.$coreMethods.message("warning", this.$t('message.selectAData'));
      }
    },
    //类型联想控件
    queryDictRows() {
      let self = this;
     let params={
        codeType: "MD_INVOICE_TYPE",
        valueType: 'ZH'
      }
      if(this.$cookies.get('language')==='en'){
		  params={
        codeType: "MD_INVOICE_TYPE",
        valueType: 'EN',
        }
		 }
       queryDictionaryByCodeType(params).then((res) => {
        self.invoiceTypeList = res.records.MD_INVOICE_TYPE;
        let dict = [];
        res.res.records.MD_INVOICE_TYPE.forEach((item) => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          dict.push(param);
        });
        self.$hotTableUtils.registDict({
          'MD_INVOICE_TYPE': dict,
        });
      });
    },
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-form-item__label {
  line-height: 36px !important;
}
::v-deep.bottom-input{
  .el-form-item__content{
  width: 70%;
}
}
.widthSH{
   width:100%
}
.content-panel{
  margin-bottom: 5px;
}
.bottom-module{
  margin: 5px 0px 0px 0px !important;
  border: 1px solid;
  background-color: #fff;
}
.addlLRmargin{
    margin-left: -11px;
    margin-right: -11px;
}
.addRowlLRmargin{
    margin-left: 11px;
    margin-right: 11px;
}
.nomargin{
  margin-bottom: unset !important;
}
::v-deep .TTL{
  .el-form-item__label,.el-form-item__content{
  line-height: unset !important;
}
}
#invoiceDetailContainer{
  padding-bottom: unset !important;
}
</style>
